import { BadgePercent, Headphones, ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { SearchPanel } from "../../components/SearchPanel";

export const PERKS = [
  [BadgePercent, "Best rate, booked direct", "Promotion codes and member specials apply instantly."],
  [ShieldCheck, "Live availability", "Rooms and rates come straight from the reservation system."],
  [Headphones, "Real people", "Our reservations team is on hand before and after you book."],
];

export const useSlide = (slides, ms = 6000) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (slides.length < 2) {
      return undefined;
    }
    const t = setInterval(() => setI((x) => (x + 1) % slides.length), ms);
    return () => clearInterval(t);
  }, [slides.length, ms]);
  return [slides[i % Math.max(1, slides.length)] || {}, i];
};

export const useHero = (data) => {
  const h = data.hero_text?.[data.design || "classic"] || {};
  return { headline: h.headline?.trim() || "", intro: h.intro?.trim() || "" };
};

export const Intro = ({ text, className = "" }) => (text ? <p className={`mt-5 max-w-2xl whitespace-pre-line leading-relaxed ${className}`} data-testid="hero-intro">{text}</p> : null);

export const Perks = ({ variant = "lines" }) => (
  <section className={`container-x mt-20 grid gap-6 md:grid-cols-3 ${variant === "lines" ? "md:gap-10" : ""}`} data-testid="home-perks">
    {PERKS.map(([Icon, t, d], k) => (
      <div key={t} className={variant === "tiles" ? "rounded-3xl bg-brand p-8 text-paper" : variant === "numbers" ? "border-l border-ink/10 pl-6" : "border-t border-ink/10 pt-6"}>
        {variant === "numbers" ? <span className="font-mono text-xs text-gold">0{k + 1}</span> : <Icon className={`h-6 w-6 ${variant === "tiles" ? "text-paper" : "text-gold"}`} strokeWidth={1.25} />}
        <h3 className={`mt-4 text-lg font-medium ${variant === "tiles" ? "text-paper" : "text-ink"}`}>{t}</h3>
        <p className={`mt-1 text-sm ${variant === "tiles" ? "text-paper/80" : "text-ink/60"}`}>{d}</p>
      </div>
    ))}
  </section>
);

export const SearchCard = ({ title = "Search for Rooms", compact, className = "", onSearch }) => (
  <div className={`rounded-3xl border border-brand/10 bg-white/95 p-6 sm:p-8 ${className}`} data-testid="home-search-card">
    <p className="eyebrow">Reservations</p>
    <h2 className="mb-6 mt-1 font-serif text-3xl text-ink sm:text-4xl">{title}</h2>
    <SearchPanel compact={compact} onSearch={onSearch} />
  </div>
);
